import React from 'react';
export function BonusSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/bBbitNVpyoL11rCKEWCwH8/BONO_1_POLITICA_Y_CIUDADANIA.png',
    title: 'Mapa Anual de Política y Ciudadanía',
    subtitle: 'Ves el año completo de un vistazo'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/anH34fRy1sotJyGytEGhjL/BONO_2_PYC.png',
    title: 'Evaluaciones Prácticas + Consignas',
    subtitle: 'Evaluás sin improvisar'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/2MBuwwrwYtEroDGsj9b5qu/BONO_3_PYC.png',
    title: 'Casos Reales para Explicar Política',
    subtitle: 'Los alumnos entienden porque lo viven'
  }];
  return <section className="bg-[#1e3a5a] py-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-47">
      <div className="max-w-7xl mx-auto text-center" data-id="element-48">
        <div className="inline-block bg-[#d4a853] text-[#1e3a5a] font-black text-lg px-6 py-2 rounded-full mb-10 animate-pulse shadow-lg" data-id="element-49">
          ¡GRATIS POR EL DÍA DE HOY!
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-50">
          Llevate estos bonos exclusivos con tu compra
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-51">
          {bonuses.map((bonus, index) => <div key={index} className="group cursor-pointer" onClick={scrollToPurchase} data-id="element-52">
              <div className="bg-white/10 p-3 rounded-xl shadow-xl transform transition duration-300 group-hover:-translate-y-2 group-hover:shadow-2xl border border-white/20" data-id="element-53">
                <img src={bonus.image} alt={bonus.title} className="w-full rounded-lg" data-id="element-54" />
              </div>
              <p className="text-white mt-4 font-bold text-lg" data-id="element-55">{bonus.title}</p>
              <p className="text-[#d4a853] text-sm" data-id="element-56">{bonus.subtitle}</p>
            </div>)}
        </div>

        <p className="text-[#d4a853] mt-10 text-lg font-medium" data-id="element-57">
          👆 Hacé clic en cualquier bono para acceder a la oferta completa
        </p>
      </div>
    </section>;
}